import { createFileRoute } from '@tanstack/react-router'

import KecamatanPage from '@/components/pages/backoffice/_klb-penyuluh/_kecamatan/containers/KecamatanPage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/kecamatan/')({
  component: KecamatanPage
  // validateSearch: dtFiltersSearchParamsSchema
})
